import { Layout, Eyebrow, ChromeHeading } from "../components/funnel";
import { WithEmail } from "../components/legal/MailLink";

const Bullet = ({ text }) => {
  const idx = text.indexOf(": ");
  const lead = idx > 0 && idx < 40 ? text.slice(0, idx + 1) : null;
  return (
    <li className="relative pl-6 before:absolute before:left-0 before:top-[0.7em] before:h-1.5 before:w-1.5 before:rotate-45 before:bg-[var(--gold)]">
      {lead ? <><strong className="font-semibold text-[#f4efe4]">{lead}</strong><WithEmail text={text.slice(idx + 1)} /></> : <WithEmail text={text} />}
    </li>
  );
};

const LegalSection = ({ heading, paras = [], bullets = [], i }) => (
  <section className="pt-10" data-testid={`legal-section-${i}`}>
    <h2 className="font-display text-2xl uppercase leading-tight tracking-[0.02em] text-[#f4efe4] sm:text-3xl">{heading}</h2>
    <div className="mt-4 space-y-4">
      {paras.map((p) => <p key={p}><WithEmail text={p} /></p>)}
      {bullets.length > 0 && <ul className="space-y-3">{bullets.map((b) => <Bullet key={b} text={b} />)}</ul>}
    </div>
  </section>
);

export default function LegalPage({ page }) {
  return (
    <Layout>
      <article className="gutter py-16 sm:py-24" data-testid={`legal-page-${page.slug}`}>
        <div className="mx-auto max-w-[720px] text-[16px] leading-[1.75] text-[#cfc7b6]">
          <Eyebrow data-testid="legal-eyebrow">{page.eyebrow}</Eyebrow>
          <ChromeHeading as="h1" className="mt-4 text-[44px] sm:text-6xl" data-testid="legal-title">{page.title}</ChromeHeading>
          <p className="font-mono-plex mt-4 text-[12px] tracking-[0.1em] text-[#a59f93]" data-testid="legal-effective">{page.sub}</p>
          <div className="hairline mt-8" aria-hidden="true" />
          <p className="mt-8 text-[17px] text-[#e4dccb]" data-testid="legal-intro"><WithEmail text={page.intro} /></p>
          {page.sections.map((s, i) => <LegalSection key={s.heading} i={i + 1} {...s} />)}
        </div>
      </article>
    </Layout>
  );
}
